import { getThumbnailWindowSpec } from '@cutr/constants/windows/presets';
import { WindowPresetId } from '@cutr/constants/windows/presets';
import { useTranslation } from 'react-i18next';

import { useRenderStyles } from '../interfaces/renderer/renderStyles';
import { WindowThumbnail } from '../interfaces/renderer/WindowThumbnail';
import styles from './PresetThumbnailCard.module.css';

type PresetThumbnailCardProps = {
  presetId: WindowPresetId;
};

export const PresetThumbnailCard = ({ presetId }: PresetThumbnailCardProps) => {
  const { t } = useTranslation();
  const windowSpec = getThumbnailWindowSpec(presetId);
  const renderStyles = useRenderStyles('presetSelector');

  return (
    <div className={styles.card}>
      <WindowThumbnail
        windowSpec={windowSpec}
        containerHeight={140}
        renderStyles={renderStyles}
      />
      <span className={styles.title}>{t(`windows.presets.${presetId}`)}</span>
    </div>
  );
};
